'use client';

import { StarterHomePublicPS } from './StarterHomePublicPS';
import { StarterHomePS } from './StarterHomePS';
import { StarterHomeClinicalPharmacy } from './StarterHomeClinicalPharmacy';

export interface IStarterInitialContentProps {
  logged?: boolean;
  tag?: string;
  template?: string;
}

export const StarterInitialContent = {
  HomePublicPS: StarterHomePublicPS,
  HomePS: StarterHomePS,
  HomeClinicalPharmacy: StarterHomeClinicalPharmacy,
};
